import { HTMLAttributes } from 'react'
import { useNavigate } from 'react-router-dom'

import clsx from 'clsx'

import { ChildProps } from '@/common/util/props'

import { useDisclosure } from '@/components/view/utils/disclousure/DisclosureProvider'

interface Props extends ChildProps {
  attributes?: HTMLAttributes<HTMLTableRowElement>
  href?: string
  fillType?: 'caution' | 'critical' | 'transparent'
  onClick?: () => void
}

const ClickableTableRow = ({
  children,
  href,
  attributes,
  fillType,
  onClick = undefined
}: Props) => {
  const navigate = useNavigate()
  const { showing: disclosureShowing } = useDisclosure()

  const handleClick = (event: React.MouseEvent<HTMLTableRowElement>) => {
    const target = event.target as HTMLElement

    if (target.closest('a, button, label, input, select, textarea')) {
      return
    }

    if (onClick) {
      onClick()
      return
    }

    if (href) {
      navigate(href)
    }
  }

  return (
    <tr
      role='row'
      className={clsx(
        'border-secondary group cursor-pointer border-b border-solid last:border-none',
        disclosureShowing && 'pointer-events-none',
        fillType == 'caution'
          ? 'bg-surface-caution hover:bg-surface-caution-hover'
          : fillType == 'critical'
            ? 'bg-surface-critical hover:bg-surface-critical-hover'
            : 'bg-surface hover:bg-fill-hover'
      )}
      onClick={handleClick}
      {...attributes}
    >
      {children}
    </tr>
  )
}

export default ClickableTableRow
